function loadEnvironmentVariable(name: string): string | undefined {
  // Used for local development
  const viteEnv = import.meta.env;
  // @ts-expect-error - Injected by CD
  const windowEnv = window?.__ENV as ImportMetaEnv;
  return windowEnv?.[name] ?? viteEnv?.[name];
}

function requireEnvironmentVariable(name: string): string {
  const value = loadEnvironmentVariable(name);
  if (!value) {
    throw new Error(`Missing environment variable: ${name}`);
  }
  return value;
}

export const envVars = {
  PROD_EXTENSION_ID: requireEnvironmentVariable('VITE_PROD_EXTENSION_ID'),
  STAGING_EXTENSION_ID: requireEnvironmentVariable('VITE_STAGING_EXTENSION_ID'),
  WEBAUTHN_IFRAME_SRC: loadEnvironmentVariable('VITE_WEBAUTHN_IFRAME_SRC'),
  INFINEX_ENVIRONMENT: requireEnvironmentVariable('VITE_INFINEX_ENVIRONMENT'),
  ENABLED_EVM_CHAIN_KEYS: loadEnvironmentVariable(
    'VITE_ENABLED_EVM_CHAIN_KEYS'
  ),
  WEBAUTHN_RPID: requireEnvironmentVariable('VITE_WEBAUTHN_RPID'),

  // Datadog RUM
  DATADOG_RUM_APPLICATION_ID: loadEnvironmentVariable(
    'VITE_DATADOG_RUM_APPLICATION_ID'
  ),
  DATADOG_RUM_CLIENT_TOKEN: loadEnvironmentVariable(
    'VITE_DATADOG_RUM_CLIENT_TOKEN'
  ),
  DATADOG_RUM_SITE: loadEnvironmentVariable('VITE_DATADOG_RUM_SITE'),
};

export const WORKER_MAIN_PROXY_PATH = '/main-proxy';
